import { useAppConfig } from '@plato/app-core/hooks/use-app-config';
import { PlatoLogo } from '@plato/ui-legacy/assets/icons/plato-logo';
import { PlatoLogoSeasonal } from '@plato/ui-legacy/assets/icons/plato-logo-seasonal';
import { PlatoLogoWithText } from '@plato/ui-legacy/assets/icons/plato-logo-with-text';
import { PlatoLogoWithTextSeasonal } from '@plato/ui-legacy/assets/icons/plato-logo-with-text-seasonal';

type Props = {
    className?: string;
};

/**
 * Main-nav Plato mark — renders the seasonal variant when the `enableSeasonalLogo`
 * feature flag is on, otherwise the default logo. The flag check lives here (inside
 * AppConfigContext) so the leaf logo components stay pure and usable outside the
 * provider (e.g. the super-admin layout).
 */
export function NavLogo({ className = '' }: Props) {
    const { enableSeasonalLogo } = useAppConfig();
    return enableSeasonalLogo ? (
        <PlatoLogoSeasonal className={className} />
    ) : (
        <PlatoLogo className={className} />
    );
}

export function NavLogoWithText({ className = '' }: Props) {
    const { enableSeasonalLogo } = useAppConfig();
    return enableSeasonalLogo ? (
        <PlatoLogoWithTextSeasonal className={className} />
    ) : (
        <PlatoLogoWithText className={className} />
    );
}
